import { useQuery } from "@apollo/react-hooks";
import { GET_CATEGORY_TREND } from "../api/analytics";
import getTimezoneOffset from "../utils/timezone";

const timezoneOffset = getTimezoneOffset();

export default ({ categoryId, months, startDate, endDate } = {}) => {
  const isCustomIncomplete = !months && (!startDate || !endDate);

  const { loading, error, data } = useQuery(GET_CATEGORY_TREND, {
    variables: {
      categoryId,
      months,
      startDate,
      endDate,
      timezoneOffset,
    },
    fetchPolicy: "cache-and-network",
    skip: !categoryId || isCustomIncomplete,
  });

  return {
    loading,
    error,
    categoryTrend: data && data.monthlySpending,
  };
};
